import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPdf = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V7.5L14.5 2Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 2V8H20",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.546 18V13.03H8.387C8.96567 13.03 9.39733 13.1817 9.682 13.485C9.97133 13.7837 10.116 14.1827 10.116 14.682C10.116 15.214 9.95267 15.6177 9.626 15.893C9.304 16.1637 8.86067 16.299 8.296 16.299H7.519V18H6.546ZM7.519 15.424H8.17C8.47333 15.424 8.702 15.3563 8.856 15.221C9.01467 15.0857 9.094 14.899 9.094 14.661C9.094 14.4277 9.017 14.2433 8.863 14.108C8.709 13.9727 8.492 13.905 8.212 13.905H7.519V15.424ZM10.2109 18V13.03H11.8559C12.6352 13.03 13.2606 13.261 13.7319 13.723C14.2032 14.1803 14.4389 14.78 14.4389 15.522C14.4389 16.264 14.2079 16.8637 13.7459 17.321C13.2886 17.7737 12.6656 18 11.8769 18H10.2109ZM11.1839 17.125H11.8139C12.2899 17.125 12.6749 16.9733 12.9689 16.67C13.2676 16.3667 13.4169 15.984 13.4169 15.522C13.4169 15.0553 13.2722 14.6703 12.9829 14.367C12.6936 14.0637 12.3249 13.912 11.8769 13.912H11.1839V17.125ZM14.6209 18V13.03H17.9179V13.912H15.5939V15.235H17.5329V16.117H15.5939V18H14.6209Z",
			fill: "currentColor"
		})
	]
});
export default SvgPdf;
